import React, { Fragment } from 'react'
import BestResearchPaper from '../best-research-paper/BestResearchPaper'
import PagesHeading from '../pages-heding/PagesHeading'

const BestResearchPaperPage = (props) => {
  return (
    <Fragment>
        <PagesHeading page_title={props.page_title}></PagesHeading>
        <BestResearchPaper></BestResearchPaper>
    </Fragment>
  )
}

export default BestResearchPaperPage